/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ExternalUserEmailUpdateRequest,
    ExternalUserEmailUpdateRequestFromJSON,
    ExternalUserEmailUpdateRequestToJSON,
} from '../models/ExternalUserEmailUpdateRequest';
import {
    type ExternalUserEmailUpdateResponse,
    ExternalUserEmailUpdateResponseFromJSON,
    ExternalUserEmailUpdateResponseToJSON,
} from '../models/ExternalUserEmailUpdateResponse';
import {
    type ExternalUserNameUpdateRequest,
    ExternalUserNameUpdateRequestFromJSON,
    ExternalUserNameUpdateRequestToJSON,
} from '../models/ExternalUserNameUpdateRequest';
import {
    type ExternalUserNameUpdateResponse,
    ExternalUserNameUpdateResponseFromJSON,
    ExternalUserNameUpdateResponseToJSON,
} from '../models/ExternalUserNameUpdateResponse';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/ProblemDetails';

export interface ApiUserB2cProfileUserIdEmailPutRequest {
    userId: string;
    externalUserEmailUpdateRequest: ExternalUserEmailUpdateRequest;
}

export interface ApiUserB2cProfileUserIdNamePutRequest {
    userId: string;
    externalUserNameUpdateRequest: ExternalUserNameUpdateRequest;
}

export interface ApiUserB2cProfileUserIdPhoneDeleteRequest {
    userId: string;
}

/**
 * 
 */
export class UserB2cProfileApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiUserB2cProfileUserIdEmailPut without sending the request
     */
    async apiUserB2cProfileUserIdEmailPutRequestOpts(requestParameters: ApiUserB2cProfileUserIdEmailPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUserB2cProfileUserIdEmailPut().'
            );
        }

        if (requestParameters['externalUserEmailUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'externalUserEmailUpdateRequest',
                'Required parameter "externalUserEmailUpdateRequest" was null or undefined when calling apiUserB2cProfileUserIdEmailPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/user-b2c-profile/{userId}/email`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalUserEmailUpdateRequestToJSON(requestParameters['externalUserEmailUpdateRequest']),
        };
    }

    /**
     */
    async apiUserB2cProfileUserIdEmailPutRaw(requestParameters: ApiUserB2cProfileUserIdEmailPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalUserEmailUpdateResponse>> {
        const requestOptions = await this.apiUserB2cProfileUserIdEmailPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalUserEmailUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUserB2cProfileUserIdEmailPut(requestParameters: ApiUserB2cProfileUserIdEmailPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalUserEmailUpdateResponse> {
        const response = await this.apiUserB2cProfileUserIdEmailPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUserB2cProfileUserIdNamePut without sending the request
     */
    async apiUserB2cProfileUserIdNamePutRequestOpts(requestParameters: ApiUserB2cProfileUserIdNamePutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUserB2cProfileUserIdNamePut().'
            );
        }

        if (requestParameters['externalUserNameUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'externalUserNameUpdateRequest',
                'Required parameter "externalUserNameUpdateRequest" was null or undefined when calling apiUserB2cProfileUserIdNamePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/user-b2c-profile/{userId}/name`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalUserNameUpdateRequestToJSON(requestParameters['externalUserNameUpdateRequest']),
        };
    }

    /**
     */
    async apiUserB2cProfileUserIdNamePutRaw(requestParameters: ApiUserB2cProfileUserIdNamePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalUserNameUpdateResponse>> {
        const requestOptions = await this.apiUserB2cProfileUserIdNamePutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalUserNameUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUserB2cProfileUserIdNamePut(requestParameters: ApiUserB2cProfileUserIdNamePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalUserNameUpdateResponse> {
        const response = await this.apiUserB2cProfileUserIdNamePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUserB2cProfileUserIdPhoneDelete without sending the request
     */
    async apiUserB2cProfileUserIdPhoneDeleteRequestOpts(requestParameters: ApiUserB2cProfileUserIdPhoneDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUserB2cProfileUserIdPhoneDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/user-b2c-profile/{userId}/phone`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUserB2cProfileUserIdPhoneDeleteRaw(requestParameters: ApiUserB2cProfileUserIdPhoneDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUserB2cProfileUserIdPhoneDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUserB2cProfileUserIdPhoneDelete(requestParameters: ApiUserB2cProfileUserIdPhoneDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserB2cProfileUserIdPhoneDeleteRaw(requestParameters, initOverrides);
    }

}
